import { cn } from "@artprov/design-system";
import PropTypes from "prop-types";

export const ContainerCardGrid = ({ children, className }) => {
  return (
    <div
      className={cn(
        "w-full mx-auto",
        "grid gap-x-7 gap-y-6",
        "grid-cols-[repeat(auto-fit,minmax(180px,1fr))]",
        "justify-center",
        className
      )}
    >
      {children}
    </div>
  );
};

ContainerCardGrid.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

